// ======================================================================
// FILE:
// src/modules/expense_management/claims/services/businessReferenceService.js
//
// MODULE:
// Expense Management
//
// FEATURE:
// Business Reference Service
// ======================================================================

//import axiosClient from "../../../services/axiosClient";
import axiosClient from "../../../../api/axiosClient";

const BASE_URL =
   "/api/expense-management";

const businessReferenceService = {

  // ==========================================================
  // EXPENSE SOURCES
  // ==========================================================

  async getExpenseSources() {

    const response =
      await axiosClient.get(
        `${BASE_URL}/masters/expense-sources`
      );

    return (
      response.data.data || []
    );

  },

  // ==========================================================
  // REFERENCE TYPES
  // ==========================================================

  async getReferenceTypes(
    expenseSource
  ) {

    const response =
      await axiosClient.get(
        `${BASE_URL}/masters/reference-types`,
        {
          params: {
            expense_source: expenseSource,
          },
        }
      );

    return (
      response.data.data || []
    );

  },

  // ==========================================================
  // SEARCH
  // ==========================================================

  async searchBusinessReference(
    params
  ) {

    const response =
      await axiosClient.get(
        `${BASE_URL}/business-reference/search`,
        {
          params,
        }
      );

    return (
      response.data.data
    );

  },

  // ==========================================================
  // DETAILS
  // ==========================================================

  async getBusinessReferenceDetails(

    referenceId,

    expenseSource,

    referenceType

  ) {

    const response =
      await axiosClient.get(

        `${BASE_URL}/business-reference/details/${referenceId}`,

        {

          params: {

            expense_source:
              expenseSource,

            reference_type:
              referenceType,

          },

        }

      );

    return (
      response.data.data
    );

  },

};

export default businessReferenceService;